<template>
  <th
    v-if="queryKey"
    scope="col"
  >
    <router-link
      :to="{
        name: $route.name,
        query: {
          sortBy: queryKey,
          sortOrder: $route.query.sortBy === queryKey && $route.query.sortOrder === 'asc'
            ? 'desc'
            : 'asc',
        },
      }"
    >
      {{label}}

      <span
        v-if="queryKey && $route.query.sortBy === queryKey"
        class="material-icons"
      >{{ $route.query.sortOrder === 'desc'
        ? 'arrow_drop_down'
        : 'arrow_drop_up'
      }}</span>
    </router-link>
  </th>

  <th
    v-else
    scope="col"
  >
    {{label}}
  </th>
</template>

<script>
  export default {
    props: {
      label: {
        required: true,
        type: String,
      },

      queryKey: {
        type: String,
      },
    },
  }
</script>

<style lang="scss" scoped>
  th {
    a {
      color: inherit;
    }
  }

</style>
